module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Medium.024dc32.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Medium.woff
// module id = /HsU
// module chunks = 0